export default angular
  .module('doxy.common.directives.utilities', [])
  .directive('ngEnter', function () {
    return function (scope, element, attrs) {
      element.on('keydown keypress', function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.ngEnter);
          });

          event.preventDefault();
        }
      });
    };
  }).name;
